import React from 'react';
import { MapContainer, TileLayer, Marker, Popup, ZoomControl } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix Leaflet icon issue
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

let DefaultIcon = L.icon({
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41]
});
L.Marker.prototype.options.icon = DefaultIcon;

const InteractiveMap = () => {
  const position = [-8.67858056, 120.94754444]; // Center point for Ngada
  
  const kecamatanData = [
    { name: 'Bajawa', pos: [-8.78503889, 120.97466389], stats: 'Ibukota Kabupaten, Pusat Pemerintahan' },
    { name: 'Riung', pos: [-8.42098056, 121.02646667], stats: 'Kawasan Wisata Taman Laut 17 Pulau' },
    { name: 'Aimere', pos: [-8.84195278, 120.85750278], stats: 'Sentra Produksi Moke & Pelabuhan' },
    { name: 'Golewa', pos: [-8.82214167, 121.06175000], stats: 'Kawasan Pertanian & Hortikultura' },
    { name: 'Soa', pos: [-8.69826667, 121.03451667], stats: 'Bandara Soa & Air Panas Mengeruda' },
    { name: 'Riung Barat', pos: [-8.52322500, 120.94877500], stats: 'Kawasan Pertanian Lahan Kering' },
    { name: 'Wolomeze', pos: [-8.61553056, 121.06902500], stats: 'Potensi Peternakan & Pertanian' },
    { name: 'Bajawa Utara', pos: [-8.67858056, 120.94754444], stats: 'Wilayah Penyangga Ibukota' },
    { name: 'Golewa Barat', pos: [-8.82936111, 121.02122222], stats: 'Sentra Sayur-sayuran' },
    { name: 'Golewa Selatan', pos: [-8.87023333, 121.09576389], stats: 'Kawasan Pesisir Selatan' },
    { name: 'Inerie', pos: [-8.94303056, 120.96172222], stats: 'Wisata Budaya & Gunung Inerie' },
    { name: 'Jerebuu', pos: [-8.89576944, 120.99670833], stats: 'Kawasan Tradisional Bena' },
  ];

  const customMarker = (color) => L.divIcon({
    className: 'custom-div-icon',
    html: `<div style="background-color:${color}; width: 12px; height: 12px; border-radius: 50%; border: 2px solid white; box-shadow: 0 0 10px ${color}"></div>`,
    iconSize: [12, 12],
    iconAnchor: [6, 6]
  });

  return (
    <div style={{ height: '500px', width: '100%', borderRadius: '24px', overflow: 'hidden', boxShadow: 'var(--shadow-lg)', border: '1px solid var(--gray-100)', position: 'relative' }}>
      <MapContainer center={position} zoom={10} scrollWheelZoom={false} style={{ height: '100%', width: '100%' }} zoomControl={false}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
          url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
        />
        <ZoomControl position="bottomright" />
        
        {kecamatanData.map((kec, i) => (
          <Marker 
            key={i} 
            position={kec.pos} 
            icon={customMarker('var(--primary-500)')}
          >
            <Popup>
              <div style={{ padding: '5px' }}>
                <strong style={{ fontSize: '14px', color: 'var(--primary-700)' }}>{kec.name}</strong>
                <p style={{ margin: '5px 0 0', fontSize: '12px', color: 'var(--gray-600)' }}>{kec.stats}</p>
                <div style={{ marginTop: '8px', paddingTop: '8px', borderTop: '1px solid #eee' }}>
                  <a href={`/dataset?kecamatan=${kec.name}`} style={{ fontSize: '11px', color: 'var(--primary-600)', fontWeight: '600', textDecoration: 'none' }}>Lihat Data →</a>
                </div>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>

      {/* FLOATING OVERLAY */}
      <div style={{ 
        position: 'absolute', 
        top: '20px', 
        left: '20px', 
        zIndex: 1000, 
        background: 'rgba(255,255,255,0.8)', 
        backdropFilter: 'blur(10px)', 
        padding: '15px', 
        borderRadius: '16px', 
        border: '1px solid rgba(255,255,255,0.3)',
        boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
        maxWidth: '250px'
      }}>
        <h4 style={{ margin: 0, fontSize: '0.9rem', color: 'var(--gray-900)' }}>Peta Sebaran Sektoral</h4>
        <p style={{ fontSize: '0.75rem', color: 'var(--gray-500)', margin: '5px 0 10px' }}>Klik penanda untuk melihat profil singkat wilayah.</p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '0.7rem' }}>
            <span style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--primary-500)' }} /> Terintegrasi
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '0.7rem' }}>
            <span style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--gold-500)' }} /> Tahap Entry
          </div>
        </div>
      </div>
    </div>
  );
};

export default InteractiveMap;
